import { NoData as DsNoData, NoDataProps, mergeSx } from '@cast/design-system';

/** @deprecated Use `<NoData />` from `@cast/design-system` instead */
export const NoData = (props: NoDataProps) => {
  return <DsNoData {...props} sx={mergeSx({ marginTop: '32px' }, props.sx)} />;
};
